<template>
  <div v-test="'employee-selection-list'">
    <EmployeeSelection standalone @submit="$emit('submit')" />
  </div>
</template>

<script setup lang="ts">
import { useAvailabilityStore } from '@/stores/availability';
import { useBookingStore } from '@/stores/booking';
import { useCompanyStore } from '@/stores/company';
import { storeToRefs } from 'pinia';
import EmployeeSelection from '../_shared/employee-selection/index.vue';

defineEmits(['submit']);

const { resetDate } = useBookingStore();
const { resetAvailabilityStore } = useAvailabilityStore();
resetDate();
resetAvailabilityStore();

const { settings } = useCompanyStore();

if (settings.employee_selection_first) {
  const { serviceIds } = storeToRefs(useBookingStore());
  serviceIds.value = [];
}

const bookingStore = useBookingStore();
bookingStore.employeeId = null;
</script>
